import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton/index.jsx";
import References from "../../components/References/index.jsx";
import LdsBlockList from "../../components/LdsBlockList/LdsBlockList.jsx";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_5_0_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <div className="col-sm-8 module-content">
        <main className="module-content">
          <section className="mb-5 learning-heading">
            <h1 className="blue text-uppercase b mt-5">
              5.0.0 For Radiologists: Importance of Standardized Reporting and
              Report Template Components<sup>1,2</sup>
            </h1>
            <p className="mt-3 mb-0">Estimated time to complete: 1 minute</p>
          </section>
          <section>
            <div className="content-block mb-5">
              <p>
                As a bridge between radiologists and referring physicians, the
                radiology report is often the primary form of communication with
                referring physicians. While all parts of the radiology report
                are essential, the findings and impression sections are
                particularly important to clarify and identify actionable
                information that needs to be conveyed to the referring
                physician.<sup>1</sup>
              </p>
              <p className="fz-sm">
                Note: Scan interpretation should be done independent of clinical
                information.
              </p>
              <p>
                <br />
                There are 4 recommended components in the report based on the
                Society of Nuclear Medicine and Molecular Imaging (SNMMI) and
                European Association of Nuclear Medicine (EANM) guidelines for
                amyloid PET imaging of the brain. Each section of the report is
                summarized with key points to include when completing an amyloid
                PET imaging report, keeping in mind what information is relevant
                to the referring physician.<sup>2</sup>
              </p>
            </div>
            <LdsBlockList
              items={[
                {
                  title: "Indications for Ordering",
                  bookmarked: false,
                  iconSlug: "pin",
                },
                {
                  title: "Technique",
                  bookmarked: false,
                  iconSlug: "wrench",
                },
                {
                  title: "Findings",
                  bookmarked: true,
                  iconSlug: "memo",
                },
                {
                  title: "Impression",
                  bookmarked: true,
                  iconSlug: "mag",
                },
              ]}
            />
          </section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-5/isi", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-5/module-5-0-1", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <ol className="no-indent fz-sm">
              <li>
                Hartung MP, Bickle IC, Gaillard F, Kanne JP. How to create a
                great radiology report. <em>Radiographics.</em>{" "}
                2020;40(6):1658-1670.
              </li>
              <li>Minoshima S, Drzezga AE, Barthel H, et al. SNMMI Procedure Standard/EANM Practice Guideline for Amyloid PET Imaging of the Brain 1.0. <em>J Nucl Med.</em> 2016;57(8):1316-1322.</li>
            </ol>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_5_0_0;
